export const primary = "#EFC230";
